var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SocketEvent, } from '@debbie/common/dist/web-sockets';
import * as lib from '../api/users';
import { fetchLoadable } from '../fetchLoadable';
import { dispatch } from '../internal';
import { emitEvent, getCurrentActivities, subscribeToEvent } from '../socket';
import * as actionTypes from './actionTypes';
export const getAll = () => fetchLoadable(actionTypes.FETCH_ALL_USERS, lib.getAll);
export const getById = (id) => fetchLoadable(actionTypes.FETCH_USER_BY_ID, lib.getById, { id });
let itemsToAdd = {};
let itemsToRemove = {};
const newActiveUser = (tenantId, newActiveUsers) => {
    if (!itemsToAdd[tenantId]) {
        itemsToAdd[tenantId] = [];
    }
    if (Array.isArray(newActiveUsers)) {
        itemsToAdd[tenantId].push(...newActiveUsers);
    }
    else {
        itemsToAdd[tenantId].push(newActiveUsers);
    }
    setTimeout(() => {
        if (Object.keys(itemsToAdd).length > 0) {
            dispatch({ type: actionTypes.NEW_ACTIVE_USER, payload: itemsToAdd });
            itemsToAdd = {};
        }
    }, 0);
};
const newUserActivity = (tenantId, wsId, activity) => __awaiter(void 0, void 0, void 0, function* () {
    // Active user event have to be received before this event
    yield new Promise((resolve) => setTimeout(resolve, 250));
    dispatch({
        type: actionTypes.NEW_USER_ACTIVITY,
        payload: { tenantId, wsId, activity },
    });
});
const removeUserActivity = (tenantId, wsId, data) => __awaiter(void 0, void 0, void 0, function* () {
    // Needs to wait as long as newUserActivity to prevent race condition
    yield new Promise((resolve) => setTimeout(resolve, 250));
    dispatch({
        type: actionTypes.REMOVE_USER_ACTIVITY,
        payload: { tenantId, wsId, data },
    });
});
const userLeft = (tenantId, wsId) => {
    if (!itemsToRemove[tenantId]) {
        itemsToRemove[tenantId] = [];
    }
    itemsToRemove[tenantId].push(wsId);
    setTimeout(() => {
        if (Object.keys(itemsToRemove).length > 0) {
            dispatch({ type: actionTypes.USER_LEFT, payload: itemsToRemove });
            itemsToRemove = {};
        }
    }, 10);
};
const resetActiveUsers = () => {
    setTimeout(() => {
        dispatch({
            type: actionTypes.RESET_ACTIVE_USERS,
            payload: {},
        });
        const activities = getCurrentActivities();
        for (const activity of activities) {
            emitEvent(SocketEvent.NEWUSERACTIVITY, activity);
        }
    }, 0);
};
subscribeToEvent(SocketEvent.NEWACTIVEUSERS, newActiveUser);
subscribeToEvent(SocketEvent.CONNECT, resetActiveUsers);
subscribeToEvent(SocketEvent.NEWUSERACTIVITY, newUserActivity);
subscribeToEvent(SocketEvent.REMOVEUSERACTIVITY, removeUserActivity);
subscribeToEvent(SocketEvent.USERLEFT, userLeft);
//# sourceMappingURL=actions.js.map